var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasGallery
    ? _c(
        "div",
        { staticClass: "product-gallery-slot" },
        [
          _c("product-gallery", {
            attrs: { title: _vm.TITLE, products: _vm.PRODUCTS }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }